import React, { Component } from "react";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavbarToggler,
  Collapse,
  NavItem,
} from "reactstrap";
import { NavLink } from "react-router-dom";

const style = {
  "display" : "flex",
  "justifyContent": "center",
  "alignItems": "center"
};

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isNavOpen: false,
    };

    this.toggleNav = this.toggleNav.bind(this);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  toggleNav() {
    if (window.innerWidth < 1024)
    this.setState({
      isNavOpen: !this.state.isNavOpen,
    });
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.isNavOpen) {
      this.toggleNav();
    }
  }

  render() {

    return (
      <div  ref={this.setWrapperRef}>
        <Navbar dark expand="lg" fixed="top">
          <div className="container-fluid ml-auto ml-md-0">
            <NavbarBrand className="ml-xs-3 mr-xs-0 mx-auto brand-logo" style={{ "display": "flex","alignItems": "center"}} href="/">
              <img
                className="mr-md-4"
                src="assets/images/logo.png"
                height="70"
                width="55"
                alt="Военная Кафедра UTM" />
                <p className="mb-0 d-none d-md-block " style={{"fontSize" : "larger"}} >Военная Кафедра UTM</p>
            </NavbarBrand>
            <NavbarToggler onClick={this.toggleNav} className="ml-auto mr-0" />
            <Collapse isOpen={this.state.isNavOpen} navbar>
              <Nav navbar className="ml-lg-auto mr-lg-0">
                <NavItem>
                  <NavLink onClick={this.toggleNav} className="nav-link header-text mr-lg-4" style={style} to="/home">
                    <span className="fa fa-home fa-lg mr-2"></span> Домой
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink onClick={this.toggleNav} className="nav-link header-text mr-lg-4" style={style} to="/files">
                    <span className="fa fa-file fa-lg mr-2"></span> Файлы
                  </NavLink>
                </NavItem>
                {/* <NavItem>
                  <NavLink onClick={this.toggleNav} className="nav-link header-text mr-lg-4" style={style} to="/articles">
                    <span className="fa fa-file-text fa-lg mr-2"></span> Статьи
                  </NavLink>
                </NavItem> */}
                <NavItem>
                  <NavLink onClick={this.toggleNav} className="nav-link header-text mr-lg-4" style={style} to="/gallery">
                    <span className="fa fa-camera fa-lg mr-2"></span> Галерея
                  </NavLink>
                </NavItem>
                {/* <NavItem>
                  <NavLink onClick={this.toggleNav} className="nav-link header-text" style={style} to="/contacts">
                    <span className="fa fa-address-card fa-lg mr-2"></span> Контакты
                  </NavLink>
                </NavItem> */}
              </Nav>
            </Collapse>
          </div>
        </Navbar>
      </div>
    );
  }
}

export default Header;
